export interface IDonorShieldDirectDuplicateCounts {
    //donorAliasCount: number,
    recipientAliasCount: number
}